module.exports = __webpack_public_path__ + "8fa04d49c3081cc3ec999c6eddcbd608.png";